import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModalClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 5l14 14M19 5 5 19",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeLinecap: "round"
	})
});
export default SvgModalClose;
